import store from '@/store/store';

export const flagIsEnabled = (flag) => () => {
  return !store.getters['featureFlag/isEnabled'](flag);
};
